import React, { useContext } from 'react'
import "./CSS/ShopCategory.css"
import { ShopContext } from '../Context/ShopContext'
import Item from '../Components/Items/Item.jsx'

const ShopCategory = (props) => {
  // ✅ Correct key name + default empty array
  const { allProducts = [] } = useContext(ShopContext)

  return (
    <div className='shop-category'>
      <div className="shopcategory-indexSort">
        <p>Our Products</p>
        <hr />
      </div>

      <div className="shopcategory-products">
        {allProducts
          .filter(item => item.category === props.category)
          .map(item => (
            <Item
              key={item.id}
              id={item.id}
              name={item.name}
              image={item.image}
              new_price={item.new_price}
              old_price={item.old_price}
            />
          ))}
      </div>

      <div className="shopcategory-loadmore">
        Explore More
      </div>
    </div>
  )
}

export default ShopCategory
